import type { Template } from "@/types";

export const PO_07_H1_V6: Template[] = [
    {
        id: "po-07-h1v6-01",
        name: "PO 01 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 30, y: 229, width: 542, height: 393, rotation: 0, imageRotation: 0 },
            { id: "2", x: 619, y: 137, width: 175, height: 285, rotation: 0, imageRotation: 0 },
            { id: "3", x: 802, y: 137, width: 175, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 985, y: 137, width: 175, height: 285, rotation: 0, imageRotation: 0 },
            { id: "5", x: 619, y: 430, width: 175, height: 284, rotation: 0, imageRotation: 0 },
            { id: "6", x: 802, y: 430, width: 175, height: 284, rotation: 0, imageRotation: 0 },
            { id: "7", x: 985, y: 430, width: 175, height: 284, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-02",
        name: "PO 02 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 49, y: 160, width: 496, height: 336, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 504, width: 119, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 176, y: 504, width: 118, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 302, y: 504, width: 118, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 428, y: 504, width: 118, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 641, y: 224, width: 244, height: 401, rotation: 0, imageRotation: 0 },
            { id: "7", x: 893, y: 224, width: 244, height: 401, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-03",
        name: "PO 03 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 106, y: 122, width: 388, height: 289, rotation: 0, imageRotation: 0 },     
            { id: "2", x: 106, y: 419, width: 190, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 304, y: 419, width: 190, height: 309, rotation: 0, imageRotation: 0 },
            { id: "4", x: 638, y: 122, width: 362, height: 606, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1008, y: 122, width: 128, height: 197, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1008, y: 327, width: 128, height: 196, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1008, y: 531, width: 128, height: 196, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-04",
        name: "PO 04 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 133, y: 166, width: 161, height: 255, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 429, width: 161, height: 254, rotation: 0, imageRotation: 0 },
            { id: "3", x: 302, y: 166, width: 161, height: 255, rotation: 0, imageRotation: 0 },
            { id: "4", x: 302, y: 429, width: 161, height: 254, rotation: 0, imageRotation: 0 },
            { id: "5", x: 637, y: 166, width: 261, height: 517, rotation: 0, imageRotation: 0 },
            { id: "6", x: 907, y: 166, width: 233, height: 167, rotation: 0, imageRotation: 0 },        
            { id: "7", x: 907, y: 341, width: 233, height: 342, rotation: 0, imageRotation: 0 },           
        ],
    },

    {
        id: "po-07-h1v6-05",
        name: "PO 05 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 48, y: 244, width: 498, height: 361, rotation: 0, imageRotation: 0 },
            { id: "2", x: 672, y: 112, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 672, y: 324, width: 142, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 672, y: 535, width: 142, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 822, y: 112, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 972, y: 112, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "7", x: 822, y: 324, width: 292, height: 414, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-06",
        name: "PO 06 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 46, y: 116, width: 504, height: 351, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 46, y: 474, width: 163, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 217, y: 474, width: 163, height: 259, rotation: 0, imageRotation: 0 },
            { id: "4", x: 388, y: 474, width: 162, height: 259, rotation: 0, imageRotation: 0 },
            { id: "5", x: 638, y: 158, width: 336, height: 534, rotation: 0, imageRotation: 0 },
            { id: "6", x: 982, y: 159, width: 164, height: 263, rotation: 0, imageRotation: 0 },
            { id: "7", x: 982, y: 430, width: 164, height: 262, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-07",
        name: "PO 07 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 125, y: 58, width: 230, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 58, width: 229, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 600, y: 58, width: 229, height: 363, rotation: 0, imageRotation: 0 },
            { id: "4", x: 837, y: 58, width: 229, height: 363, rotation: 0, imageRotation: 0 },
            { id: "5", x: 125, y: 429, width: 230, height: 363, rotation: 0, imageRotation: 0 },
            { id: "6", x: 837, y: 429, width: 229, height: 363, rotation: 0, imageRotation: 0 },
            { id: "7", x: 363, y: 429, width: 466, height: 363, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-08",
        name: "PO 08 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_08.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 0, y: 171, width: 148, height: 250, rotation: 0, imageRotation: 0 },
            { id: "2", x: 156, y: 171, width: 148, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 312, y: 171, width: 148, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 0, y: 429, width: 148, height: 250, rotation: 0, imageRotation: 0 },
            { id: "5", x: 156, y: 429, width: 148, height: 250, rotation: 0, imageRotation: 0 },
            { id: "6", x: 312, y: 429, width: 148, height: 250, rotation: 0, imageRotation: 0 },
            { id: "7", x: 468, y: 171, width: 721, height: 508, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-09",
        name: "PO 09 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 536, height: 850, rotation: 0, imageRotation: 0 },
            { id: "2", x: 652, y: 185, width: 473, height: 330, rotation: 0, imageRotation: 0 },
            { id: "3", x: 652, y: 522, width: 89, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 749, y: 522, width: 88, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 845, y: 522, width: 88, height: 144, rotation: 0, imageRotation: 0 },
            { id: "6", x: 941, y: 522, width: 88, height: 144, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1037, y: 522, width: 88, height: 144, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-10",
        name: "PO 10 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_10.png",
        size: [1190, 850],
        style: {},
        slots: [         
            { id: "1", x: 63, y: 124, width: 124, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 328, width: 124, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 63, y: 532, width: 124, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 195, y: 124, width: 800, height: 603, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1003, y: 124, width: 124, height: 196, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1003, y: 328, width: 124, height: 196, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1003, y: 532, width: 124, height: 195, rotation: 0, imageRotation: 0 }
        ],
    }
];